export default __webpack_public_path__ + "static/header-pns-734f250d6744e468947dc40413d5974a.jpg";